(() => {
  const VAT_RATE = 0.20;

  const LABEL_ID = "vat-including-label";
  const EXVAT_ID = "vat-exvat-line";

  const isVatExempt = () => document.body.classList.contains("vatexempt");

  // BALANCE product page detection:
  // Only run if there is a product-price element that contains shopify-payment-terms (your product page does).
  const findMainProductPrice = () => {
    const nodes = Array.from(document.querySelectorAll("product-price"));
    return nodes.find((n) => n.querySelector("shopify-payment-terms")) || null;
  };

  const formatGBP = (cents) => `£${(cents / 100).toFixed(2)}`;

  const getVariantPriceCentsFromTerms = (root) => {
    const termsEl = root?.querySelector("shopify-payment-terms");
    if (!termsEl) return null;

    const variantId = termsEl.getAttribute("variant-id");
    const metaStr = termsEl.getAttribute("shopify-meta");
    if (!variantId || !metaStr) return null;

    const unescaped = metaStr.replace(/&quot;/g, '"');

    try {
      const meta = JSON.parse(unescaped);
      const v = (meta.variants || []).find((x) => String(x.id) === String(variantId));
      if (!v?.full_price) return null;

      const numeric = Number(String(v.full_price).replace(/[^0-9.]/g, ""));
      if (!Number.isFinite(numeric)) return null;

      return Math.round(numeric * 100);
    } catch {
      return null;
    }
  };

  const ensureIncludingLabel = (priceSpan) => {
    let label = priceSpan.parentElement.querySelector(`#${LABEL_ID}`);
    if (!label) {
      label = document.createElement("span");
      label.id = LABEL_ID;
      label.className = "vat-including-label";
      label.style.marginLeft = "0.35em";
      priceSpan.insertAdjacentElement("afterend", label);
    }
    return label;
  };

  const ensureExVatLine = (root) => {
    let line = root.querySelector(`#${EXVAT_ID}`);
    if (!line) {
      line = document.createElement("div");
      line.id = EXVAT_ID;
      line.className = "vat-exvat-line";

      const priceContainer = root.querySelector('[ref="priceContainer"]') || root;
      priceContainer.insertAdjacentElement("afterend", line);
    }
    return line;
  };

  const updateTaxNote = (taxNoteEl, exempt) => {
    if (!taxNoteEl) return;

    taxNoteEl.classList.add("vat-tax-note");

    const original = taxNoteEl.textContent || "";
    const hasShipping = /Shipping calculated at checkout\./i.test(original);
    const shippingText = hasShipping ? "Shipping calculated at checkout." : "";

    if (exempt) {
      taxNoteEl.innerHTML = shippingText
        ? `This product is <b>exempt from VAT</b>.<br>${shippingText}`
        : `This product is <b>exempt from VAT</b>.`;

      taxNoteEl.classList.add("vat-tax-note--exempt");
      taxNoteEl.classList.remove("vat-tax-note--standard");
    } else {
      const cleaned = original.replace(/Taxes included\.\s*/i, "").trim();
      taxNoteEl.textContent = cleaned || shippingText || "";

      taxNoteEl.classList.add("vat-tax-note--standard");
      taxNoteEl.classList.remove("vat-tax-note--exempt");
    }
  };

  const applyVatUI = () => {
    const root = findMainProductPrice();
    if (!root) return;

    const priceSpan = root.querySelector(".price");
    if (!priceSpan) return;

    const taxNote = root.querySelector(".tax-note");
    const label = ensureIncludingLabel(priceSpan);
    const exVatLine = ensureExVatLine(root);

    if (isVatExempt()) {
      label.textContent = "";
      label.style.display = "none";

      exVatLine.innerHTML = "";
      exVatLine.style.display = "none";

      updateTaxNote(taxNote, true);
      return;
    }

    label.textContent = "(Price inc.VAT)";
    label.style.display = "";

    const cents = getVariantPriceCentsFromTerms(root);
    if (typeof cents === "number") {
      const exVatCents = Math.round(cents / (1 + VAT_RATE));

      // ✅ Split ex VAT line into a big price + subdued bracket text
      exVatLine.innerHTML = `
        <span class="vat-exvat-price">${formatGBP(exVatCents)}</span>
        <span class="vat-bracket">(Price ex.VAT)</span>
      `;
      exVatLine.style.display = "";
    } else {
      exVatLine.innerHTML = "";
      exVatLine.style.display = "none";
    }

    updateTaxNote(taxNote, false);
  };

  // throttle so rerenders don’t hammer performance
  let scheduled = false;
  const scheduleApply = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      applyVatUI();
    });
  };

  const init = () => {
    applyVatUI();

    const bodyObs = new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.type === "attributes" && m.attributeName === "class") scheduleApply();
      }
    });
    bodyObs.observe(document.body, { attributes: true });

    const attachPriceObserver = () => {
      const root = findMainProductPrice();
      if (!root) return false;

      const priceObs = new MutationObserver(() => scheduleApply());
      priceObs.observe(root, { childList: true, subtree: true, characterData: true });
      return true;
    };

    let tries = 0;
    const t = setInterval(() => {
      tries += 1;
      if (attachPriceObserver() || tries > 40) clearInterval(t);
      scheduleApply();
    }, 250);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
